import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PanelMenuModel } from './contract/panel-menu-model.contract';

import { PanelMenuBadgePipe } from './pipes/panel-menu-badge.pipe';
import { PanelMenuModelTransformPipe } from './pipes/panel-menu-model-transform.pipe';

@Component({
  selector: 'osp-panel-menu',
  standalone: true,
  imports: [PanelMenuModule, PanelMenuModelTransformPipe, PanelMenuBadgePipe],
  templateUrl: './panel-menu.component.html',
  styleUrl: './panel-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PanelMenuComponent {
  @HostBinding('class.osp-panel-menu') protected hostClassEnabled = true;
  @Input() model: PanelMenuModel = [];
}
